<template>
    <ae-container>
        <template slot="top-left">
            <div class="wr-picture">
                <router-link
                        :to="profileLink"
                        v-b-tooltip.hover
                        :title="fullName"
                >
                    <b-img
                            :src="profilePicture"
                            alt="Votre avatar"
                            height="50px"
                            width="50px"
                            rounded="circle"
                    />
                </router-link>
            </div>
            <div class="wr-top-left-infos">
                <p>
                    <i class="far fa-bell"></i>
                    Notifications: <span>{{notifications}}</span>
                </p>
                <p>
                    <i class="far fa-star"></i>
                    Nombres de participations: <span>{{home.stats.reservations}}</span>
                </p>
                <p>
                    <i class="fas fa-users"></i>
                    Mon réseau: <span>{{home.stats.friends}}</span>
                </p>
            </div>
        </template>
        <template slot="middle-left">
            <home-placeholder
                    target="post"
            />
        </template>
        <template slot="bottom-left">
            <h2>
                <b>Rejoindre une activité dans mon entreprise</b>
            </h2>
            <home-bottom-meeting
                    v-for="(meeting, index) of home.meetings.slice(0, 4)"
                    :key="`home-meeting-${index}`"
                    :meeting="meeting"
            />
            <home-placeholder
                    v-if="home.meetings.length === 0"
                    target="meetings"
            />
            <home-placeholder
                    target="communities"
            />
        </template>
        <template slot="center">
            <relais-roadlog-info class="pt-1"/>
            <ae-block
                :properties="['margin-bottom', 'my-0', 'scroll-x']"
                class="py-2 bg-whitesmoke home--block mt-2"
            >
                <home-top-worker
                    class="mx-1"
                    v-for="(action, index) of home.top"
                    :key="`home-actionBar-action-${index}`"
                    :action="action"
                />
            </ae-block>
            <relais-roadlog
                    style="margin-top: 3px"
            />
        </template>
        <template slot="top-right">
            <h2 class="p-1">
                <b>Mon réseau, mes collègues</b>
            </h2>
            <social-create-post-comment
                    typeObject="post"
                    typePost="post"
                    @publish="onPost($event)"
                    moodable
                    roleable
                    mode="light"
                    class="p-2"
            />
        </template>
        <template slot="bottom-right">
            <timeline-container
                    class="br-3"
                    :elements="actuality(4)"
                    :bordered="true"
                    @update="update()"
                    @refresh="update()"
                    :key="`home-desktop-timeline`"
            />
        </template>
    </ae-container>
</template>
<script>
    import RelaisRoadlog from "../../../views/relais/Roadlog";
    import RelaisRoadlogInfo from "../../../views/relais/RoadlogInfo";
    import TimelineContainer from "../../TimelineContainer";
    import SocialCreatePostComment from "../../SocialCreatePostComment";
    import HomePlaceholder from "../Placeholder";
    import {APP_API_URL} from '@/utils/types/setting'
    import AeContainer from "../../Container";
    import HomeMiddleMeetingType from "../middle/MeetingType";
    import HomeBottomMeeting from "../bottom/Meeting";
    import HomeTopWorker from "../top/Worker";
    import AeBlock from "../../Block";

    export default {
        name: 'home-desktop-relais',
        components: {
            HomeBottomMeeting,
            HomeMiddleMeetingType,
            AeContainer,
            HomePlaceholder,
            SocialCreatePostComment,
            TimelineContainer,
            RelaisRoadlog,
            RelaisRoadlogInfo,
            HomeTopWorker,
            AeBlock
        },
        data: () => ({
            APP_API_URL,
            apiOrigin: null,
        }),
        async mounted() {
            const {origin} = new URL(this.$store.state.base.setting[APP_API_URL])
            this.apiOrigin = origin
        },
        methods: {
            async update() {
                await this.$store.dispatch('base/appInterface/home')
            },
            actuality(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'actuality'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            },
            reminders(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'coach_todo'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            },
            async onPost(postComment) {
                await this.$store.dispatch('base/timeline/load', {limit: 4, offset: 0})
            }
        },
        computed: {
            notifications() {
                return this.$store.state.base.notification.count
            },
            home() {
                return this.$store.state.base.appInterface.home
            },
            user() {
                return this.$store.state.base.account.information
            },
            hasRoleWorker() {
                return this.$store.getters['base/account/getIsWorker'](this.user)
            },
            hasRoleCoach() {
                if (!this.user) return false
                return this.$store.getters['base/account/getIsCoach'](this.user)
            },
            hasRoleRelais() {
                return this.$store.getters['base/account/getIsWorkerRelais'](this.user)
            },
            hasRoleReferent() {
                return this.$store.getters['base/account/getIsCoachReferent'](this.user)
            },
            profileLink() {
                return this.hasRoleWorker ? {
                    name: 'profile',
                    params: {id: this.user.id}
                } : {
                    name: 'account-settings'
                }
            },
            folder() {
                return `/static/img/icons/navbar/${this.iconsColor}/`
            },
            color() {
                let color = 'bleu'
                if (
                    this.interface &&
                    this.interface.colors &&
                    this.interface.colors.navbar &&
                    this.interface.colors.navbar['icon-color']
                ) color = this.interface.colors.navbar['icon-color']
                return color
            },
            iconsColor() {
                const color = this.color
                switch (color) {
                    case 'bleu':
                        return 'blue'
                    case 'noir':
                        return 'black'
                    case 'blanc':
                    default:
                        return 'white'
                }
            },
            fullName() {
                return this.$store.getters['base/account/getFullName'](this.user)
            },
            profilePicture() {
                return this.$store.getters['base/account/getAvatar'](this.user) !== '/static/img/icons/user.png' ?
                    this.$store.getters['base/account/getAvatar'](this.user) : `${this.folder}profile.png`
            },
        }
    }
</script>
